<template>
    <form-row title="Entitlement Period" :no_border="true" class="mt-8">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_entitlement_period"
                v-model="has_entitlement_period"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        has_entitlement_period: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
